import ExcelJS from 'exceljs';
import moment from 'moment';

export class ReportAdriaExcelHelpers {

	constructor() {
		this.baseURLAPI = "";
	}

	getAllRoomsCornaro() {
		
		var i;
		
		// HC1
		
		var roomsHC1 = [[1],[],[],[],[]];
		
		for(i=101; i<=109; i++) {
			roomsHC1[1].push(i);
		}

		for(i=201; i<=209; i++) {
			roomsHC1[2].push(i);
		}

		for(i=301; i<=309; i++) {
			roomsHC1[3].push(i);
		}
		
		for(i=401; i<=406; i++) {
			roomsHC1[4].push(i);
		}
		
		// HC2
		
		var roomsHC2 = [[],[],[],[],[],[]];
		
		for(i=2; i<=4; i++) {
			roomsHC2[0].push(i);
		}

		for(i=121; i<=129; i++) {
			roomsHC2[1].push(i);
		}

		for(i=221; i<=229; i++) {
			roomsHC2[2].push(i);
		}

		for(i=321; i<=329; i++) {
			roomsHC2[3].push(i);
		}

		for(i=421; i<=429; i++) {
			roomsHC2[4].push(i);
		}

		for(i=521; i<=525; i++) {
			roomsHC2[5].push(i);
		}

		// HC3

		var roomsHC3 = [[],[],[],[],[],[]];

		for(i=131; i<=149; i++) {
			roomsHC3[1].push(i);
		}

		for(i=231; i<=249; i++) {
			if (i !== 244) {
				roomsHC3[2].push(i);
			}
		}

		for(i=331; i<=350; i++) {
			roomsHC3[3].push(i);
		}

		for(i=430; i<=441; i++) {
			roomsHC3[4].push(i);
		}

		for(i=531; i<=541; i++) {
			roomsHC3[5].push(i);
		}
		
		return [roomsHC1,roomsHC2,roomsHC3];
	}

	async serverDataConvertCsvToJson(dataUrl) {
		
		var url = this.baseURLAPI + "/dataconvertcsvtojson?url=" +  encodeURIComponent(dataUrl);
		
		var jsonObj = null;
		
		try {
			var res = await fetch(url);
			jsonObj = await res.json();
		} catch (err) {
		}

		return jsonObj;
	}
	
	getTwoDigits(num1) {
		var string1 = String(num1).padStart(2, '0');
		return string1;
	}

	getTimeStringFromMin(min1) {
		
		var hour = Math.floor(min1 / 60);
		var min2 = min1 - hour * 60;

		var timeString = hour + "h " + this.getTwoDigits(min2) + "min";
		return timeString;
	}

	getDateTimeStringFromUnixTimeSec(unixTimeSec) {

		if (unixTimeSec === null) {
			unixTimeSec = 0;
		}
		
		if (unixTimeSec === 0) {
			return "";
		}

		var currentDateObj = new Date();
		var dateObj = new Date(unixTimeSec * 1000);
		
		var year1 = currentDateObj.getFullYear();
		var year2 = dateObj.getFullYear();
		
		var dateTimeString;
		//if (year1 === year2) {
		//	dateTimeString = moment(dateObj).format('DD/MM HH:mm');
		//} else {
			dateTimeString = moment(dateObj).format('DD.MM.YYYY HH:mm');
		//}

		return dateTimeString;
	}

	setExcelCell(worksheet, cellRef, cellValue, horizontalAlignement) {
		var cellObj = worksheet.getCell(cellRef);
		cellObj.value = cellValue;
		cellObj.alignment = { horizontal: horizontalAlignement };	
		return cellObj;
	}

	createWorksheet1OneRoom(worksheet, itemObj, row) {

		var cellObj;
		var roomNumber = itemObj.roomNumber;
		var acMinutes = itemObj.acMinutes;
		var acPercentage = itemObj.acPercentage;
		var cardPresentMinutes = itemObj.cardPresentMinutes;
		var cardPresentPercentage = itemObj.cardPresentPercentage;
		var maxRoomTemperature = itemObj.maxRoomTemperature;
		var maxSetTemperature = itemObj.maxSetTemperature;
		var minRoomTemperature = itemObj.minRoomTemperature;
		var minSetTemperature = itemObj.minSetTemperature;
		var averageRoomTemperature = itemObj.averageRoomTemperature;
		var adria = itemObj.adria;
		var milenij = itemObj.milenij;

		var acMinutesString = this.getTimeStringFromMin(acMinutes);
		var cardPresentString = this.getTimeStringFromMin(cardPresentMinutes);

		cellObj = this.setExcelCell(worksheet, "A" + row, roomNumber, "right");
		if (milenij !== 1) {
			if (acMinutes > 10*60) {
				cellObj.font = { bold: true, color: { argb: "FFA500" } };
			} else {
				if (acPercentage > 5*60) {
					cellObj.font = { bold: true, color: { argb: "000000" } };
				}
			}
		}

		cellObj = this.setExcelCell(worksheet, "B" + row, acMinutesString, "right");
		
		cellObj = this.setExcelCell(worksheet, "C" + row, acPercentage, "right");
		if (acPercentage > 90) {
			cellObj.font = { bold: true, color: { argb: "FFA500" } };
		} else {
			if (acPercentage > 50) {
				cellObj.font = { bold: true, color: { argb: "000000" } };
			}
		}
		
		averageRoomTemperature = parseFloat(averageRoomTemperature);
		
		if (averageRoomTemperature < 1) {
			averageRoomTemperature = " ";
		}
		
		var milenijString = "";
		if (milenij === 1) {
			milenijString = "Da";
		}

		cellObj = this.setExcelCell(worksheet, "D" + row, cardPresentString, "right");
		cellObj = this.setExcelCell(worksheet, "E" + row, cardPresentPercentage, "right");

		cellObj = this.setExcelCell(worksheet, "F" + row, averageRoomTemperature, "center");
		if (averageRoomTemperature < 20) {
			cellObj.font = { bold: true, color: { argb: "0070C0" } };
		}
		if (averageRoomTemperature >= 23) {
			cellObj.font = { bold: true, color: { argb: "C00000" } };
		}
		cellObj.numFmt = "0.0";
		
		cellObj = this.setExcelCell(worksheet, "G" + row, minSetTemperature + "/" + minRoomTemperature, "center");
		cellObj = this.setExcelCell(worksheet, "H" + row, maxSetTemperature + "/" + maxRoomTemperature, "center");

		cellObj = this.setExcelCell(worksheet, "I" + row, milenijString, "center");
		cellObj = this.setExcelCell(worksheet, "J" + row, adria, "center");
	}
	
	findItemFromDataArray(dataArray, roomNumber1) {

		var i;
		var itemObj;
		var roomNumber2;
		
		for(i=0; i<dataArray.length; i++) {
			itemObj = dataArray[i];
			roomNumber2 = itemObj.roomNumber;
			if (roomNumber1 === roomNumber2) {
				return itemObj;
			}
		}
		
		return null;
	}
	
	createWorksheet1OneFloor(worksheet, dataArray, floorArray, row) {

		var i;
		var roomNumber;
		var itemObj;

		for(i=0; i<floorArray.length; i++) {
			roomNumber = floorArray[i];
			itemObj = this.findItemFromDataArray(dataArray, roomNumber);
			this.createWorksheet1OneRoom(worksheet, itemObj, row);
			row ++;
		}

		return row;
	}
	
	createWorksheet1OneBuilding(worksheet, dataArray, buildingName, buildingArray, row) {
		
		var cellObj;
		
		cellObj = this.setExcelCell(worksheet, "A" + row, buildingName, "left");
		cellObj.font = { bold: true, color: { argb: "000000" } };
		row ++;

		cellObj = worksheet.getCell("A" + row);
		cellObj.font = { bold: true, color: { argb: '0000FF' } };
		cellObj.value = "Soba";
		cellObj.alignment = { horizontal: 'right' };
		
		cellObj = worksheet.getCell("B" + row);
		cellObj.font = { bold: true, color: { argb: '0000FF' } };
		cellObj.value = "Klima vrijeme";
		cellObj.alignment = { horizontal: 'right' };
		
		cellObj = worksheet.getCell("C" + row);
		cellObj.font = { bold: true, color: { argb: '0000FF' } };
		cellObj.value = "Klima postotak (%)";
		cellObj.alignment = { horizontal: 'right' };
		
		cellObj = worksheet.getCell("D" + row);
		cellObj.font = { bold: true, color: { argb: '0000FF' } };
		cellObj.value = "Kartica odlagač vrijeme";
		cellObj.alignment = { horizontal: 'right' };
		
		cellObj = worksheet.getCell("E" + row);
		cellObj.font = { bold: true, color: { argb: '0000FF' } };
		cellObj.value = "Kartica odlagač postotak (%)";
		cellObj.alignment = { horizontal: 'right' };
		
		cellObj = worksheet.getCell("F" + row);
		cellObj.font = { bold: true, color: { argb: '0000FF' } };
		cellObj.value = "Prosječna stvarna temp (C)";
		cellObj.alignment = { horizontal: 'center' };
		
		cellObj = worksheet.getCell("G" + row);
		cellObj.font = { bold: true, color: { argb: '0000FF' } };
		cellObj.value = "Min temp (ciljana/stvarna C)";
		cellObj.alignment = { horizontal: 'center' };
		
		cellObj = worksheet.getCell("H" + row);
		cellObj.font = { bold: true, color: { argb: '0000FF' } };
		cellObj.value = "Max temp (ciljana/stvarna C)";
		cellObj.alignment = { horizontal: 'center' };
		
		cellObj = worksheet.getCell("I" + row);
		cellObj.font = { bold: true, color: { argb: '0000FF' } };
		cellObj.value = "Milenij";
		cellObj.alignment = { horizontal: 'center' };
		
		cellObj = worksheet.getCell("J" + row);
		cellObj.font = { bold: true, color: { argb: '0000FF' } };
		cellObj.value = "Adria";
		cellObj.alignment = { horizontal: 'center' };
		
		row ++;

		var i;
		var floorArray;
		
		for(i=0; i<buildingArray.length; i++) {
			floorArray = buildingArray[i];
			row = this.createWorksheet1OneFloor(worksheet, dataArray, floorArray, row);
		}
		row ++;

		return row;
	}
	
	createWorksheet1(workbook, year, month, day, dataArray, unixTimeSec) {

		var cellRef;
		var cellObj;
		var row = 1;
		
		var worksheet = workbook.addWorksheet("Klime");
		
		// title
		var title = "Cornaro " + day + "." + month + "." + year + " - Klime";
		cellObj = this.setExcelCell(worksheet, "A" + row, title, "left");
		cellObj.font = { bold: true };
		row ++;

		// time data prepared
		var timeString = "Podaci obrađeni: " + this.getDateTimeStringFromUnixTimeSec(unixTimeSec);
		cellObj = this.setExcelCell(worksheet, "A" + row, timeString, "left");
		cellObj.font = { color: { argb: '707070' } };
		row ++;
		
		row ++;
		
		if (dataArray === null) {
			return;
		}

		// header

		worksheet.columns = [
			{ key: 'A', width: 10 },
			{ key: 'B', width: 15 },
			{ key: 'C', width: 20 },
			{ key: 'D', width: 22 },
			{ key: 'E', width: 27 },
			{ key: 'F', width: 28 },
			{ key: 'H', width: 28 },
			{ key: 'G', width: 28 },
			{ key: 'I', width: 10 },
			{ key: 'J', width: 10 },
		];

		// data

		var i;
		var itemObj;

		var roomsHC1;
		var roomsHC2;
		var roomsHC3;

		[roomsHC1,roomsHC2,roomsHC3] = this.getAllRoomsCornaro();
		
		row = this.createWorksheet1OneBuilding(worksheet, dataArray, "HC1", roomsHC1, row);
		row = this.createWorksheet1OneBuilding(worksheet, dataArray, "HC2", roomsHC2, row);
		row = this.createWorksheet1OneBuilding(worksheet, dataArray, "HC3", roomsHC3, row);
	}
	
	createEmployeeArray(dataArray) {
		
		if (dataArray === null) {
			return null;
		}

		if (dataArray.length === 0) {
			return null;
		}

		var i;
		var itemObj1;
		var itemObj2;
		var employeeArray = [];
		var totalMin = 0;
		var roomArray = [];
		var prevName = "";
		var name;
		var roomNumber;
		var startHour;
		var startMin;
		var durationMin;
		var nameChangeYN;
		var roomObj;

		for(i=0; i<dataArray.length; i++) {

			itemObj1 = dataArray[i];

			name = itemObj1.name;
			roomNumber = itemObj1.roomNumber;
			startHour = itemObj1.startHour;
			startMin = itemObj1.startMin;
			durationMin = itemObj1.durationMin;

			nameChangeYN = false;
			
			if (prevName === "") {
				prevName = name;
			} else {
				if (name !== prevName) {
					nameChangeYN = true;
				}
			}

			if (nameChangeYN) {
				itemObj2 = {};
				itemObj2.name = prevName;
				itemObj2.totalMin = totalMin;
				itemObj2.roomArray = roomArray;
				employeeArray.push(itemObj2);
				prevName = name;
				totalMin = 0;
				roomArray = [];
			}

			totalMin += durationMin;
			roomObj = {};
			roomObj.roomNumber = roomNumber;
			roomObj.startHour = startHour;
			roomObj.startMin = startMin;
			roomObj.durationMin = durationMin;
			roomArray.push(roomObj);
		}

		itemObj2 = {};
		itemObj2.name = prevName;
		itemObj2.totalMin = totalMin;
		itemObj2.roomArray = roomArray;
		employeeArray.push(itemObj2);
		
		return employeeArray;
	}
	
	createWorksheet2(workbook, year, month, day, employeeArray, unixTimeSec) {

		var cellRef;
		var cellObj;
		var row = 1;
		
		var worksheet = workbook.addWorksheet("Djelatnici");
		
		// title
		var title = "Cornaro " + day + "." + month + "." + year + " - Djelatnici";
		cellObj = this.setExcelCell(worksheet, "A" + row, title, "left");
		cellObj.font = { bold: true };
		row ++;

		// time data prepared
		var timeString = "Podaci obrađeni: " + this.getDateTimeStringFromUnixTimeSec(unixTimeSec);
		cellObj = this.setExcelCell(worksheet, "A" + row, timeString, "left");
		cellObj.font = { color: { argb: '707070' } };
		row ++;
		row ++;
		
		if (employeeArray === null) {
			return;
		}

		// header

		worksheet.columns = [
			{ key: 'A', width: 30 },
			{ key: 'B', width: 12 },
			{ key: 'C', width: 12 },
			{ key: 'D', width: 12 },
		];

		cellObj = this.setExcelCell(worksheet, "A" + row, "Ime", "left");
		cellObj.font = { bold: true, color: { argb: '0000FF' } };
		
		cellObj = this.setExcelCell(worksheet, "B" + row, "Soba", "center");
		cellObj.font = { bold: true, color: { argb: '0000FF' } };
		
		cellObj = this.setExcelCell(worksheet, "C" + row, "Start", "center");
		cellObj.font = { bold: true, color: { argb: '0000FF' } };
		
		cellObj = this.setExcelCell(worksheet, "D" + row, "Minute", "center");
		cellObj.font = { bold: true, color: { argb: '0000FF' } };
		
		row ++;
		
		// data

		var i;
		var j;
		var itemObj;
		var name;
		var nameString;
		var roomNumber;
		var startHour;
		var startMin;
		var durationMin;
		var timeString;
		var roomArray;
		var roomObj;
		var totalMin;
		var nameString;

		for(i=0; i<employeeArray.length; i++) {

			itemObj = employeeArray[i];

			name = itemObj.name;
			totalMin = itemObj.totalMin;
			nameString = name + " - " + this.getTimeStringFromMin(totalMin);
			cellObj = this.setExcelCell(worksheet, "A" + row, nameString, "left");
			roomArray = itemObj.roomArray;
			
			for(j=0; j<roomArray.length; j++) {
				
				roomObj = roomArray[j];

				roomNumber = roomObj.roomNumber;
				startHour = roomObj.startHour;
				startMin = roomObj.startMin;
				durationMin = roomObj.durationMin;
			
				timeString = startHour + ":" + this.getTwoDigits(startMin);

				cellObj = this.setExcelCell(worksheet, "B" + row, roomNumber, "center");
				cellObj = this.setExcelCell(worksheet, "C" + row, timeString, "center");
				cellObj = this.setExcelCell(worksheet, "D" + row, durationMin, "center");
				row ++;
			}
		}
	}
	
	async createExcel(year, month, day) {

		var dashboardID = 1;
		var outTextArray;
		var headerJsonObj;
		var jsonArray;
		
		var filename = year + "-" + this.getTwoDigits(month) + "-" + this.getTwoDigits(day) + ".csv";
		var dataUrl = "/dashboard/" + dashboardID + "/roomsAdriaReport1/" + filename;
		var jsonArray = await this.serverDataConvertCsvToJson(dataUrl);
		var dataArray1 = null;
		var unixTimeSec1 = 0;
		if (jsonArray !== null) {
			headerJsonObj = jsonArray.header;
			unixTimeSec1 = headerJsonObj.unixTimeSec;
			dataArray1 = jsonArray.data;
		}
		
		dataUrl = "/dashboard/" + dashboardID + "/roomsAdriaReport2/" + filename;
		jsonArray = await this.serverDataConvertCsvToJson(dataUrl);
		var dataArray2 = null;
		var unixTimeSec2 = 0;
		if (jsonArray !== null) {
			headerJsonObj = jsonArray.header;
			unixTimeSec2 = headerJsonObj.unixTimeSec;
			dataArray2 = jsonArray.data;
		}
		
		if ((dataArray1 === null) && (dataArray2 === null)) {
			return null;
		}
		
		var workbook = new ExcelJS.Workbook();

		this.createWorksheet1(workbook, year, month, day, dataArray1, unixTimeSec1);
		var employeeArray = this.createEmployeeArray(dataArray2);
		this.createWorksheet2(workbook, year, month, day, employeeArray, unixTimeSec2);

		var excelBuffer = await workbook.xlsx.writeBuffer();				
		return excelBuffer;
	}
}
